/**
 * Created by Teo on 01/06/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('prospectivePatientLeadHospitalizationDiseases', {
                parent: 'prospectivePatientView',
                url: '/history',
                data: {
                    authorities: ['ROLE_REC_MANAGEMENT', 'ROLE_REC_FRONT_DESK'],
                    pageTitle: 'sigmaCrmApp.prospectivePatient.home.title'
                },
                templateUrl: 'app/displays/prospectivePatients/diseases/leadHospitalizationDiseases.html',
                controller: 'ProspectivePatientViewLeadHospitalizationDiseasesController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    /*callTypes: ['CallType', function (CallType) {
                        return CallType.query({page: 0, size: 200}).$promise;
                    }],*/
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
